import "./singleUser.scss";
import Chart from "../../components/chart/Chart";
import Navbar from "../../components/navbar/Navbar";
import Sidebar from "../../components/sidebar/Sidebar";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { CircularProgress } from "@mui/material";
import UserOrderTableList from "../../components/userOrderTable/userOrderTable";

function SingleUser() {
  const { userId } = useParams();
  const [openToast, setOpenToast] = useState(false);
  const [userData, setUserData] = useState({});
  const [ordersData, setOrdersData] = useState();
  const [publishedOn, setPublishedOn] = useState();
  const navigate = useNavigate();
  const [openLoading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [isDataAvailable, setDataAvailable] = useState(false);
  const [isOrdersAvailable, setOrdersAvailable] = useState(false);
  const [errorMessage, setErrorMessage] = useState(
    "Something went wrong.\nPlease try again"
  );
  useEffect(async () => {
    try {
      const userref = doc(db, "Users", userId);
      const userOrderref = collection(db, "Users", userId, "Library");
      const docSnap = await getDoc(userref);

      if (docSnap.exists()) {
        const euserData = docSnap.data();
        const userDataWithId = { ...euserData, id: docSnap.id };
        setUserData(userDataWithId);
        document.title = "" + euserData.user_name;
        const querySnapshot = await getDocs(userOrderref);
        setDataAvailable(true);
        setInitialLoading(false);
        if (querySnapshot.size !== 0) {
          setOrdersAvailable(true);
          const documentsData = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setOrdersData(documentsData);
          console.log(documentsData);
        } else {
          setOrdersAvailable(false);
        }
      } else {
        setInitialLoading(false);
        setErrorMessage("There is no such user available. Please try again.");
      }
    } catch (error) {
      setInitialLoading(false);
      setErrorMessage("Error - " + error);
    }
  }, []);
  return (
    <div className="singleUser">
      <Sidebar />
      {initialLoading && (
        <div className="singleUserContainer">
          <div className="intialItem">
            <CircularProgress />
          </div>
        </div>
      )}
      {!initialLoading && !isDataAvailable && (
        <div className="singleUserContainer">
          <div className="intialItem">{errorMessage}</div>
        </div>
      )}
      {!initialLoading && isDataAvailable && (
        <div className="singleUserContainer">
          <Navbar />
          <div className="top">
            <div className="left">
              {/*<div className="editButton">Edit</div>*/}
              <h1 className="title">Information</h1>
              <div className="item">
                <img src={userData.user_photo} alt="" className="itemImg" />
                <div className="details">
                  <h1 className="itemTitle">{userData.user_name}</h1>
                  <div className="detailItem">
                    <span className="itemKey">Email:</span>
                    <span className="itemValue">{userData.user_email}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Phone:</span>
                    <span className="itemValue">
                      +91{userData.mobile_number}
                    </span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">College Name:</span>
                    <span className="itemValue">{userData.user_college}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Login Device Details:</span>
                    <span className="itemValue">
                      {`${userData?.device_info?.BRAND ?? "Unknown Brand"} ${
                        userData?.device_info?.MODEL ?? "Unknown Model"
                      }`}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isOrdersAvailable && (
            <div className="bottom">
              <h1 className="title">Past orders</h1>
              <UserOrderTableList data={ordersData} userID={userId} />
            </div>
          )}
          {!isOrdersAvailable && (
            <div className="bottom">
              <p>No orders have been placed by this user.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default SingleUser;
